import { Box, Stack, Typography } from '@mui/material';
import { IPackage } from 'entities/mine-package/model';
import { COLOR_BG_SECONDARY } from 'shared';
import { NumberFormat } from 'shared/ui/number-format';

export const PackagePreviewCard = ({ name, price, image, units }: IPackage) => {
  return (
    <Stack bgcolor={COLOR_BG_SECONDARY} borderRadius={3} p={2} flex={1}>
      <Stack direction="row" gap={0.5} alignItems="center" mb={2}>
        <Box
          component="img"
          alt={`package ${name}`}
          src={image}
          sx={{ height: 32, objectFit: 'cover', aspectRatio: 1 }}
        />
        <Typography variant="h5" className="primary">
          {name}
        </Typography>
      </Stack>

      <Stack direction="row" justifyContent="space-between" mb={1}>
        <Typography variant="body2" className="secondary">
          License Price
        </Typography>
        <NumberFormat prefix="$" decimals={0} withComas variant="body2" className="accent">
          {price}
        </NumberFormat>
      </Stack>

      <Typography variant="body2" className="primary">
        {units.available}{' '}
        <Typography component="span" className="secondary">
          |{' '}
        </Typography>
        {units.total} units available
      </Typography>
    </Stack>
  );
};
